/**
 * Created by piotr.pozniak@thebeaverhead.com on 19/07/2023
 */

import React, { useCallback, useContext, useRef } from "react";
import { useEventsStore } from "../../../../hooks/redux/events";
import classnames from "classnames";
import Suggestions from "./Suggestions";
import WidgetSettingsContext from "../../../../contexts/WidgetSettingsContext";

/**
 * @param {Object} props
 * @param {function} props.fetchEvents - refetches the default (unfiltered) events collection
 * @param {function} props.searchEvents - triggers a keyword search
 * @param {String} [props.className=""] - additional class name for the wrapper
 */
const SearchInput = ({ fetchEvents, searchEvents, className = "" }) => {
  const widgetSettings = useContext(WidgetSettingsContext);
  const { events } = useEventsStore();
  const showSearch = widgetSettings["aiEnabled"];
  const showSuggestions = widgetSettings["aiShowSuggestions"];
  const inputRef = useRef();

  const placeholder = widgetSettings["aiPlaceholder"];
  const suggestions = widgetSettings["aiSuggestions"].split(";");

  const onKeyUp = useCallback((e) => {
    // on enter button
    if (e.keyCode === 13) {
      if (e.target.value.length) {
        searchEvents(e.target.value);
      } else {
        fetchEvents();
      }
    }
    //    console.log(e.target.value);
  }, []);

  /**
   *
   * @type {(function(*): void)|*}
   */
  const onSuggestion = useCallback(
    (value) => {
      searchEvents(value);
      inputRef.current.value = value;
    },
    [inputRef.current]
  );

  if (!showSearch) {
    return null;
  }

  const suggestionsComponent = showSuggestions ? (
    <Suggestions suggestions={suggestions} onSuggestionClick={onSuggestion} />
  ) : null;

  return (
    <div className={classnames(className, "dc-ai-search")}>
      <div
        className={classnames("dc-ai-search--container", {
          searching: events.fetch,
        })}
      >
        <label htmlFor="dc-ai-search-input" className="sr-only">
          {placeholder}
        </label>
        <input
          id="dc-ai-search-input"
          type={"text"}
          ref={inputRef}
          onKeyUp={onKeyUp}
          className={"dc-ai-search--container__input"}
          placeholder={placeholder}
        />
        <span className={"material-icons"} aria-hidden="true">
          search
        </span>
        <span className={"dc-ai-search--container__blur"} />
        <span className={"dc-ai-search--container__process"} />
      </div>
      {suggestionsComponent}
    </div>
  );
};

export default SearchInput;
